import { StateCreator } from 'zustand';

export interface MapEventSlice {
  drawEvent: any;
  setDrawEvent: (val: any) => void;

  clickEvent: any;
  setClickEvent: (val: any) => void;

  vertexEvent: any;
  setVertexEvent: (val: any) => void;

  mapUpdated: boolean;
  setMapUpdated: (val: boolean) => void;

  movingItem: boolean;
  setMovingItem: (val: boolean) => void;
}

// --- Initial state for easy reset ---
export const mapEventInitialState: Omit<
  MapEventSlice,
  | 'setDrawEvent'
  | 'setEditEvent'
  | 'setClickEvent'
  | 'setVertexEvent'
  | 'setMapUpdated'
  | 'setMovingItem'
> = {
  drawEvent: null,
  clickEvent: null,
  vertexEvent: null,
  mapUpdated: false,
  movingItem: false,
};

export const createMapEventSlice: StateCreator<MapEventSlice> = (set) => ({
  ...mapEventInitialState,

  setDrawEvent: (val) => set({ drawEvent: val }),
  setClickEvent: (val) => set({ clickEvent: val }),
  setVertexEvent: (val) => set({ vertexEvent: val }),
  setMapUpdated: (val) => set({ mapUpdated: val }),
  setMovingItem: (val) => set({ movingItem: val }),
});
